import styled from 'styled-components'

import { Button as LMFButton, fromMd } from '@syconium/little-miss-figgy'

export const Body = styled.div`
  display: flex;
  margin-bottom: ${o => o.theme.spacing(10)};
`

export const Button = styled(LMFButton)`
  align-items: center;
  border: 2px solid black;
  display: flex;
  height: 56px;
  justify-content: center;
  padding: 0;
  width: 100%;
  &[aria-disabled='true'] {
    opacity: 0.7;
    background-color: ${o => o.theme.color.button.disabled.fill.on.background};
    border-color: ${o => o.theme.color.button.disabled.border.on.background};
    color: ${o => o.theme.color.button.disabled.content.on.background};
  }

  ${fromMd} {
    height: 40px;
  }
`

const ButtonWrapper = styled.div`
  width: 50%;
`

export const LeftButtonWrapper = styled(ButtonWrapper)`
  padding-inline-end: ${o => o.theme.spacing(1)};
`

export const RightButtonWrapper = styled(ButtonWrapper)`
  padding-inline-start: ${o => o.theme.spacing(1)};
`
